module.exports = __webpack_public_path__ + "img/axe.9a515595.png";